import { OuiSelectOption } from 'omnium-ui/form-field';

export type TypeRelationFamille =
  | 'PARENT'
  | 'HERIT_REV'
  | 'COUSIN'
  | 'FRATRIE'
  | 'DEMI_FRERE'
  | 'ONCLE_REV'
  | 'BF_REV'
  | 'BF'
  | 'BP'
  | 'HERIT'
  | 'PARENT_REV'
  | 'ONCLE'
  | 'BP_REV'
  | 'GPERE_REV'
  | 'GPERE'
  | 'GMERE'
  | 'GMERE_REV'
  | 'GONCLE_REV'
  | 'GONCLE'
  | 'GPP_REV'
  | 'GPM_REV'
  | 'GPP'
  | 'GPM'
  | 'GFAM'
  | 'CHEF_FOYER_REV'
  | 'CHEF_FOYER'
  | 'DIVO'
  | 'VEUF_REV'
  | 'VEUF'
  | 'VEUVE_REV'
  | 'VEUVE'
  | 'EX_CONC'
  | 'EX_PACS';

export const typeRelationFamilleOptions: OuiSelectOption<TypeRelationFamille>[] = [
  { label: 'A pour héritier', value: 'HERIT' },
  { label: 'Cousin de', value: 'COUSIN' },
  { label: 'Est de la même fratrie que', value: 'FRATRIE' },
  { label: 'Demi frère / demi soeur de', value: 'DEMI_FRERE' },
  { label: 'Oncle/tante de', value: 'ONCLE' },
  { label: 'Beau-frère de', value: 'BF' },
  { label: 'Belle-soeur de', value: 'BF' },
  { label: 'Gendre/belle-fille de', value: 'BP_REV' },
  { label: 'Héritier de', value: 'HERIT_REV' },
  { label: 'Enfant de', value: 'PARENT_REV' },
  { label: 'Neveu/nièce de', value: 'ONCLE_REV' },
  { label: 'Beau-parent de', value: 'BP' },
  { label: 'A pour Grand-Père', value: 'GPERE' },
  { label: 'Est le Grand-Père de', value: 'GPERE_REV' },
  { label: 'Est la Grand-Mère de', value: 'GMERE_REV' },
  { label: 'A pour Grand-Mère', value: 'GMERE' },
  { label: 'Grand oncle/tante de', value: 'GONCLE' },
  { label: 'Petit neveu/nièce de', value: 'GONCLE_REV' },
  { label: 'A pour Grand Parent Paternel', value: 'GPP' },
  { label: 'A pour Grand Parent Maternel', value: 'GPM' },
  { label: 'Est le Grand Parent Paternel de', value: 'GPP_REV' },
  { label: 'Est le Grand Parent Maternel de', value: 'GPM_REV' },
  { label: 'Groupe familial de', value: 'GFAM' },
  { label: 'A pour Chef de Foyer', value: 'CHEF_FOYER' },
  { label: 'Est Chef de Foyer de', value: 'CHEF_FOYER_REV' },
  { label: 'Divorcé(e) de', value: 'DIVO' },
  { label: 'Veuf de', value: 'VEUF' },
  { label: 'A pour veuf', value: 'VEUF_REV' },
  { label: 'Veuve de', value: 'VEUVE' },
  { label: 'A pour veuve', value: 'VEUVE_REV' },
  { label: 'Ex-concubin(e) de', value: 'EX_CONC' },
  { label: 'Ex-Pacsé(e) de', value: 'EX_PACS' },
];
